// packages/auth/src/useAuth.ts

import { useContext } from 'react';

import { AuthContext } from './AuthContext';
import type { AuthContextValue } from './AuthContext';

/**
 * Hook to access auth state and actions.
 * Must be used within an AuthProvider.
 *
 * @example
 * const { user, isAuthenticated, login, logout } = useAuth();
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
